export const holiday = {
  "Voltar": "Back",
  "Solicitação para o dia ": "Request for the day ",
  "Acessar perfil": "Access profile",
  "Cancelar": "Cancel",
  "Tipo da solicitação:": "Request type:",
  "Período:": "Period:",
  "Observação:": "Note:",
  "Anexo:": "Attachment:",
  "Ver anexo": "View attachment",
  "por:": "by:",
  "em": "in",
  "Avalie a solicitação": "Evaluate request",
  "Recusar": "Reject",
  "Aprovar": "Approve",
  "Enviar notificação por e-mail": "Send email notification",
  "Finalizar solicitação": "Finalize request",
  "Reprovado": "Disapproved",
  "Aprovado/Cadastrado": "Approved/Registered",
  "Aviso": "Warning",
  "Férias e afastamentos": "Vacations and leaves",
  "Solicitar Férias ou Afastamento": "Request Vacation or Leave",
  "Minhas férias e afastamentos": "My vacations and leaves",
  "Período": "Period",
  "Pesquisar": "Search",
  "Tipo": "Type",
  "Data de início e fim<": "Start and end date<",
  "Qtde de dias": "Number of days",
  "Motivo": "Reason",
  "Situação": "Situation",
  "Ação": "Action",
  "Visualizar": "View",
  "Nenhuma solicitação de férias ou afastamento cadastrada no Ano selecionado.": "No vacation or leave requests registered in the selected year.",
  "Tivemos um problema com a conexão, tente novamente atualizando a página.": "We had a connection problem, please try again by refreshing the page.",
  "dia": "day",
  "dias": "days",
  "Gerenciar férias e afastamentos": "Manage vacations and leaves",
  "Funcionário": "Employee",
  "Data de início e fim": "Start and end date",
  "Solicitar Férias/Afastamento": "Request Vacation/Leave",
  "Férias": "Vacation",
  "Afastamento": "Leave",
  "Tipo de afastamento": "Type of leave",
  "Selecione": "Select",
  "Campo obrigatório.": "Required field.",
  "Início": "Start",
  "Término": "End",
  "Quantidade de dias": "Number of days",
  "Adicionar anexo": "Add attachment",
  "Motivo do ponto por exceção": "Reason for point by exception",
  "Observação": "Note",
  "Enviar Solicitação": "Send Request",
  "Não foi possivel realizar o envio da imagem. Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.": "It was not possible to send the image. Reason: file too large please send a file smaller than 2MB.",
  "Sucesso": "Success",
  "Solicitação realizada com sucesso.": "Request successfully completed."
};


// WEBPACK FOOTER //
// ./src/resources/enUS/holiday.js